<script lang="ts" setup>
import { useMainDomainLink } from '@autobid/ui/composables/useMainDomainLink'
import { onMounted, ref } from 'vue'

const url = ref<string>()
const modalActive = ref(false)
const { validate } = useMainDomainLink()

function handleClick(event: MouseEvent) {
  const link = (event.target as HTMLElement).closest('a')

  if (!link) {
    return
  }

  const href = link.getAttribute('href') || ''
  if (href.startsWith('mailto:') || href.startsWith('tel:')) {
    return
  }

  if (validate(href)) {
    return
  }

  event.preventDefault()
  url.value = href
  modalActive.value = true
}

onMounted(() => {
  document.addEventListener('click', handleClick)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClick)
})
</script>

<template>
  <common-dialog
    :opened="modalActive"
    class="z-[2147483647]"
    @close="modalActive = false"
  >
    <template #title>
      {{ $t(`external-link-dialog.title`) }}
    </template>
    <template #content>
      <i18n-t
        keypath="external-link-dialog.description"
        tag="p"
        class="whitespace-break-spaces"
      >
        <template #link>
          <CommonTooltip
            as="span"
            :tooltip="url"
            class="underline"
            show-on-mobile
          >
            {{ $t('external-link-dialog.external-domain') }}
          </CommonTooltip>
        </template>
      </i18n-t>
    </template>
    <template #buttons>
      <div class="flex justify-end flex-col sm:flex-row gap-2.5">
        <elements-button
          class="rounded-md"
          outline
          @click="modalActive = false"
        >
          {{ $t(`external-link-dialog.button.close`) }}
        </elements-button>

        <elements-button
          class="rounded-md"
          :url="url"
          @click="modalActive = false"
        >
          {{ $t(`external-link-dialog.button.continue`) }}
        </elements-button>
      </div>
    </template>
  </common-dialog>
</template>
